module.exports = __webpack_public_path__ + "static/navyknittedblanket-726080cc19e1f812387dd0f8af94d1fa.jpeg";